const Icons = {
  resultIcon: (props) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42"
          stroke="#0B1D2E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z"
          stroke="#0B1D2E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 7H16"
          stroke="#0B1D2E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 10.5H13"
          stroke="#0B1D2E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  editIcon: (props) => {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0399 3.01976L8.15988 10.8998C7.85988 11.1998 7.55988 11.7898 7.49988 12.2198L7.06988 15.2298C6.90988 16.3198 7.67988 17.0798 8.76988 16.9298L11.7799 16.4998C12.1999 16.4398 12.7899 16.1398 13.0999 15.8398L20.9799 7.95976C22.3399 6.59976 22.9799 5.01976 20.9799 3.01976C18.9799 1.01976 17.3999 1.65976 16.0399 3.01976Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9099 4.1499C15.5799 6.5399 17.4499 8.4099 19.8499 9.0899"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  noSign: (props) => {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.8999 5L4.8999 19"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  trashIcon: (props) => {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.8499 9.14014L18.1999 19.2101C18.0899 20.7801 17.9999 22.0001 15.2099 22.0001H8.7899C5.9999 22.0001 5.9099 20.7801 5.7999 19.2101L5.1499 9.14014"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3301 16.5H13.6601"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 12.5H14.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  eyeIcon: (props) => {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0001 20.2702C15.5301 20.2702 18.8201 18.1902 21.1101 14.5902C22.0101 13.1802 22.0101 10.8102 21.1101 9.40021C18.8201 5.80021 15.5301 3.72021 12.0001 3.72021C8.47009 3.72021 5.18009 5.80021 2.89009 9.40021C1.99009 10.8102 1.99009 13.1802 2.89009 14.5902C5.18009 18.1902 8.47009 20.2702 12.0001 20.2702Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  blockIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Polaroid-Four--Streamline-Flex"
        height={14}
        width={14}
        {...props}
      >
        <desc>Polaroid Four Streamline Icon: https://streamlinehq.com</desc>
        <g id="polaroid-four--photos-camera-polaroid-picture-photography-pictures-four-photo-image">
          <path
            id="Intersect"
            fill="#F1F1F1"
            d="M5.75 3.5v1.25c0 0.55228 -0.44772 1 -1 1h-3c-0.55228 0 -1 -0.44772 -1 -1V3.5h5Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_2"
            fill="#ffffff"
            d="m0.75 3.5 0 -1.75834c0 -0.54769 0.44772 -0.991672 1 -0.991672l3 0c0.55229 0.000001 1 0.443982 1 0.991672L5.75 3.5l-5 0Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_3"
            fill="#ffffff"
            d="m8.25 3.5 0 -1.75834c0 -0.54769 0.44772 -0.991672 1 -0.991672l3 0c0.5523 0.000001 1 0.443982 1 0.991672l0 1.75834 -5 0Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_4"
            fill="#ffffff"
            d="m8.25 11 0 -1.75834c0 -0.54769 0.44772 -0.99167 1 -0.99167l3 0c0.5523 0 1 0.44398 1 0.99167L13.25 11l-5 0Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_5"
            fill="#ffffff"
            d="m0.75 11 0 -1.75834c0 -0.54769 0.44772 -0.99167 1 -0.99167l3 0c0.55229 0 1 0.44398 1 0.99167L5.75 11l-5 0Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_6"
            fill="#F1F1F1"
            d="M5.75 11v1.25c0 0.5523 -0.44772 1 -1 1h-3c-0.55228 0 -1 -0.4477 -1 -1V11h5Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_7"
            fill="#F1F1F1"
            d="M13.25 3.5v1.25c0 0.55228 -0.4477 1 -1 1h-3c-0.55228 0 -1 -0.44772 -1 -1V3.5h5Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_8"
            fill="#F1F1F1"
            d="M13.25 11v1.25c0 0.5523 -0.4477 1 -1 1h-3c-0.55228 0 -1 -0.4477 -1 -1V11h5Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_9"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5.75 3.5h-5"
            strokeWidth={1}
          />
          <path
            id="Intersect_10"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5.75 11h-5"
            strokeWidth={1}
          />
          <path
            id="Intersect_11"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.25 3.5h-5"
            strokeWidth={1}
          />
          <path
            id="Intersect_12"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.25 11h-5"
            strokeWidth={1}
          />
          <path
            id="Rectangle 49"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M0.75 1.75c0 -0.55228 0.44772 -1 1 -1h3c0.55228 0 1 0.44772 1 1v3c0 0.55228 -0.44772 1 -1 1h-3c-0.55228 0 -1 -0.44772 -1 -1v-3Z"
            strokeWidth={1}
          />
          <path
            id="Rectangle 51"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M0.75 9.25c0 -0.55228 0.44772 -1 1 -1h3c0.55228 0 1 0.44772 1 1v3c0 0.5523 -0.44772 1 -1 1h-3c-0.55228 0 -1 -0.4477 -1 -1v-3Z"
            strokeWidth={1}
          />
          <path
            id="Rectangle 50"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 1.75c0 -0.55228 0.44772 -1 1 -1h3c0.5523 0 1 0.44772 1 1v3c0 0.55228 -0.4477 1 -1 1h-3c-0.55228 0 -1 -0.44772 -1 -1v-3Z"
            strokeWidth={1}
          />
          <path
            id="Rectangle 52"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 9.25c0 -0.55228 0.44772 -1 1 -1h3c0.5523 0 1 0.44772 1 1v3c0 0.5523 -0.4477 1 -1 1h-3c-0.55228 0 -1 -0.4477 -1 -1v-3Z"
            strokeWidth={1}
          />
        </g>
      </svg>
    );
  },
  tableIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Table--Streamline-Flex"
        height={14}
        width={14}
        {...props}
      >
        <desc>Table Streamline Icon: https://streamlinehq.com</desc>
        <g id="table--money-payment-table-organize-organization-business">
          <path
            id="Intersect"
            fill="#ffffff"
            d="M0.96 10.268a3.132 3.132 0 0 0 2.753 2.76c1.07 0.12 2.167 0.222 3.287 0.222s2.218 -0.102 3.287 -0.222a3.132 3.132 0 0 0 2.753 -2.76c0.114 -1.063 0.21 -2.155 0.21 -3.268s-0.096 -2.205 -0.21 -3.269a3.132 3.132 0 0 0 -2.753 -2.76C9.217 0.853 8.12 0.75 7 0.75S4.782 0.852 3.713 0.972A3.132 3.132 0 0 0 0.96 3.732C0.846 4.794 0.75 5.886 0.75 7s0.096 2.205 0.21 3.268Z"
            strokeWidth={1}
          />
          <path
            id="Vector"
            fill="#F1F1F1"
            d="M0.802 5.5h12.396a42.53 42.53 0 0 0 -0.158 -1.769 3.132 3.132 0 0 0 -2.753 -2.76C9.217 0.853 8.12 0.75 7 0.75S4.782 0.852 3.712 0.972A3.132 3.132 0 0 0 0.96 3.732C0.897 4.311 0.84 4.901 0.802 5.5Z"
            strokeWidth={1}
          />
          <path
            id="Intersect_2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M0.96 10.268a3.132 3.132 0 0 0 2.753 2.76c1.07 0.12 2.167 0.222 3.287 0.222s2.218 -0.102 3.287 -0.222a3.132 3.132 0 0 0 2.753 -2.76c0.114 -1.063 0.21 -2.155 0.21 -3.268s-0.096 -2.205 -0.21 -3.269a3.132 3.132 0 0 0 -2.753 -2.76C9.217 0.853 8.12 0.75 7 0.75S4.782 0.852 3.713 0.972A3.132 3.132 0 0 0 0.96 3.732C0.846 4.794 0.75 5.886 0.75 7s0.096 2.205 0.21 3.268Z"
            strokeWidth={1}
          />
          <path
            id="Vector 259"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.983 5.5v7.656"
            strokeWidth={1}
          />
          <path
            id="Vector 260"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M0.839 9h12.323"
            strokeWidth={1}
          />
          <path
            id="Vector_2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.198 5.5H0.802"
            strokeWidth={1}
          />
        </g>
      </svg>
    );
  },
  videoUploadIcon: (props) => {
    return (
      <svg
        width={46}
        height={40}
        viewBox="0 0 46 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.11042 5.50356C6.40484 4.09496 8.09852 3.20634 9.91527 2.98258C15.5744 2.32045 21.1357 2.31985 26.7948 2.98258C28.6116 3.20634 30.3053 4.09496 31.5997 5.50356C32.8941 6.91219 33.713 8.75766 33.9228 10.7391C34.0196 11.6809 34.1017 12.6174 34.1692 13.5503C35.7436 12.6362 37.4565 11.8028 39.24 11.1639C40.5594 10.6913 41.988 11.3049 42.4556 12.6258C43.0848 14.402 43.6935 16.9777 43.6935 19.9999C43.6935 23.0221 43.0848 25.5979 42.4556 27.3741C41.988 28.695 40.5594 29.3086 39.24 28.836C37.4562 28.1969 35.743 27.3634 34.1683 26.4492C34.1014 27.3823 34.0206 28.3191 33.9254 29.2613C33.7156 31.2429 32.8967 33.0882 31.6023 34.4967C30.3079 35.9055 28.6142 36.7941 26.7974 37.0179C21.1372 37.6795 15.5754 37.6801 9.91527 37.0179C8.09852 36.7941 6.40484 35.9055 5.11042 34.4967C3.81597 33.0882 2.99714 31.2429 2.78744 29.2612C2.14445 23.0122 2.14505 16.9882 2.78744 10.7391C2.99714 8.75766 3.81597 6.91219 5.11042 5.50356Z"
          stroke="currentColor"
          strokeWidth="3.4272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8528 16.9484V15.633"
          stroke="currentColor"
          strokeWidth="3.4272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.8955 17.0292V15.7138"
          stroke="currentColor"
          strokeWidth="3.4272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5886 22.3618C14.2994 24.4353 16.0806 25.5671 18.7421 25.5671C21.4036 25.5671 23.1848 24.4353 23.8956 22.3618"
          stroke="currentColor"
          strokeWidth="3.4272"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  minusCircle: (props) => {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.92 22C17.42 22 21.92 17.5 21.92 12C21.92 6.5 17.42 2 11.92 2C6.42004 2 1.92004 6.5 1.92004 12C1.92004 17.5 6.42004 22 11.92 22Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.92004 12H15.92"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  plusCircle: (props) => {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.00004 14.6667C11.6667 14.6667 14.6667 11.6667 14.6667 8.00004C14.6667 4.33337 11.6667 1.33337 8.00004 1.33337C4.33337 1.33337 1.33337 4.33337 1.33337 8.00004C1.33337 11.6667 4.33337 14.6667 8.00004 14.6667Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33337 8H10.6667"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 10.6667V5.33337"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  textIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <g opacity="0.5" clipPath="url(#clip0_134_12329)">
          <path
            d="M16.4384 7.76352C16.4027 6.95978 16.3344 6.16635 16.2547 5.38513C16.0529 3.40827 14.456 1.81079 12.4801 1.60002C11.3186 1.47612 10.1303 1.3772 8.9212 1.3772C7.7121 1.3772 6.52376 1.47612 5.36232 1.60002C3.38642 1.81079 1.78955 3.40827 1.58778 5.38513C1.46999 6.53918 1.3773 7.71987 1.3773 8.9211C1.3773 10.1223 1.47 11.303 1.58778 12.4571C1.78955 14.434 3.38653 16.0314 5.36245 16.2422C6.32419 16.3448 7.30438 16.4302 8.29952 16.4566"
            stroke="currentColor"
            strokeWidth="1.428"
            strokeLinecap="round"
          />
          <path
            d="M5.2023 6.73416V6.189C5.2023 5.54846 5.65957 4.99466 6.29465 4.91124C8.05765 4.67965 9.77635 4.67965 11.5393 4.91124C12.1744 4.99466 12.6317 5.54846 12.6317 6.189V6.73416"
            stroke="currentColor"
            strokeWidth="1.428"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.91708 4.73755V11.2175"
            stroke="currentColor"
            strokeWidth="1.428"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.4454 11.1895L11.6435 15.5035L11.1226 17.9531C11.0388 18.3474 11.4497 18.7203 11.8345 18.5993L14.2723 17.8329L18.1992 13.7009C18.8515 13.0146 18.7377 11.8667 17.9481 11.1684C17.1772 10.4865 16.0567 10.4959 15.4454 11.1895Z"
            stroke="currentColor"
            strokeWidth="1.428"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_134_12329">
            <rect width={20} height={20} fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  activeIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        viewBox="0 0 14 14"
        fill="none"
        {...props}
      >
        <desc>Check Square Streamline Icon: https://streamlinehq.com</desc>
        <g id="check-square--check-form-validation-checkmark-success-add-addition-box-square-tick">
          <path
            id="Intersect"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M0.959867 10.2685C1.114 11.7092 2.2727 12.8679 3.71266 13.0284 4.78221 13.1476 5.88037 13.25 7 13.25s2.21779 -0.1024 3.2873 -0.2216c1.44 -0.1605 2.5987 -1.3192 2.7528 -2.7599 0.1138 -1.06348 0.2099 -2.15535 0.2099 -3.2685 0 -1.11316 -0.0961 -2.20502 -0.2099 -3.26853 -0.1541 -1.44065 -1.3128 -2.59936 -2.7528 -2.759861C9.21779 0.852392 8.11963 0.75 7 0.75S4.78221 0.852392 3.71266 0.971609C2.2727 1.13211 1.114 2.29082 0.959867 3.73147 0.846083 4.79498 0.75 5.88684 0.75 7c0 1.11315 0.096084 2.20502 0.209867 3.2685Z"
            stroke-width="1"
          ></path>
          <path
            id="Vector"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4.5 7.625 6.31818 9.5c0.85557 -2.45768 1.5681 -3.53614 3.18182 -5"
            stroke-width="1"
          ></path>
        </g>
      </svg>
    );
  },
  wellPointsIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        {...props}
      >
        <rect width="56" height="56" rx="28" fill="#1F1F1F" />
        <path
          d="M24.3799 28L26.7899 30.42L31.6199 25.58"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.7499 18.45C27.4399 17.86 28.5699 17.86 29.2699 18.45L30.8499 19.81C31.1499 20.07 31.7099 20.28 32.1099 20.28H33.8099C34.8699 20.28 35.7399 21.15 35.7399 22.21V23.91C35.7399 24.3 35.9499 24.87 36.2099 25.17L37.5699 26.75C38.1599 27.44 38.1599 28.57 37.5699 29.27L36.2099 30.85C35.9499 31.15 35.7399 31.71 35.7399 32.11V33.81C35.7399 34.87 34.8699 35.74 33.8099 35.74H32.1099C31.7199 35.74 31.1499 35.95 30.8499 36.21L29.2699 37.57C28.5799 38.16 27.4499 38.16 26.7499 37.57L25.1699 36.21C24.8699 35.95 24.3099 35.74 23.9099 35.74H22.1799C21.1199 35.74 20.2499 34.87 20.2499 33.81V32.1C20.2499 31.71 20.0399 31.15 19.7899 30.85L18.4399 29.26C17.8599 28.57 17.8599 27.45 18.4399 26.76L19.7899 25.17C20.0399 24.87 20.2499 24.31 20.2499 23.92V22.2C20.2499 21.14 21.1199 20.27 22.1799 20.27H23.9099C24.2999 20.27 24.8699 20.06 25.1699 19.8L26.7499 18.45Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  targetIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        {...props}
      >
        <rect width="56" height="56" rx="28" fill="#F05289" />
        <path
          d="M33 28C33 28.9889 32.7068 29.9556 32.1574 30.7779C31.6079 31.6001 30.827 32.241 29.9134 32.6194C28.9998 32.9978 27.9945 33.0969 27.0246 32.9039C26.0546 32.711 25.1637 32.2348 24.4645 31.5355C23.7652 30.8363 23.289 29.9454 23.0961 28.9755C22.9031 28.0055 23.0022 27.0002 23.3806 26.0866C23.759 25.173 24.3999 24.3921 25.2222 23.8427C26.0444 23.2932 27.0111 23 28 23"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30 18.2C29.3533 18.068 28.6867 18.0013 28 18C22.477 18 18 22.477 18 28C18 33.523 22.477 38 28 38C33.523 38 38 33.523 38 28C37.9987 27.3133 37.932 26.6467 37.8 26"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.0303 27.962L32.5833 23.409M35.7403 20.345L35.1873 18.357C35.1652 18.2813 35.1247 18.2122 35.0695 18.1558C35.0144 18.0994 34.9461 18.0575 34.8709 18.0338C34.7956 18.01 34.7157 18.0052 34.6382 18.0197C34.5606 18.0343 34.4878 18.0677 34.4263 18.117C32.9903 19.29 31.4263 20.871 32.7033 23.364C35.2773 24.564 36.7473 22.946 37.8733 21.585C37.9242 21.5223 37.9587 21.4479 37.9737 21.3686C37.9886 21.2892 37.9836 21.2073 37.959 21.1304C37.9344 21.0535 37.891 20.9839 37.8327 20.928C37.7744 20.872 37.7031 20.8315 37.6253 20.81L35.7403 20.345Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  rewardIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        {...props}
      >
        <rect width="56" height="56" rx="28" fill="#0B1D2E" />
        <path
          d="M35 25C35 26.45 34.57 27.78 33.83 28.89C32.75 30.49 31.04 31.62 29.05 31.91C28.71 31.97 28.36 32 28 32C27.64 32 27.29 31.97 26.95 31.91C24.96 31.62 23.25 30.49 22.17 28.89C21.43 27.78 21 26.45 21 25C21 21.13 24.13 18 28 18C31.87 18 35 21.13 35 25Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.2501 34.47L35.6001 34.86C35.2301 34.95 34.9401 35.23 34.8601 35.6L34.5101 37.07C34.3201 37.87 33.3001 38.11 32.7701 37.48L28.0001 32L23.2301 37.49C22.7001 38.12 21.6801 37.88 21.4901 37.08L21.1401 35.61C21.0501 35.24 20.7601 34.95 20.4001 34.87L18.7501 34.48C17.9901 34.3 17.7201 33.35 18.2701 32.8L22.1701 28.9C23.2501 30.5 24.9601 31.63 26.9501 31.92C27.2901 31.98 27.6401 32.01 28.0001 32.01C28.3601 32.01 28.7101 31.98 29.0501 31.92C31.0401 31.63 32.7501 30.5 33.8301 28.9L37.7301 32.8C38.2801 33.34 38.0101 34.29 37.2501 34.47Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.58 21.98L29.17 23.16C29.25 23.32 29.46 23.48 29.65 23.51L30.72 23.69C31.4 23.8 31.56 24.3 31.07 24.79L30.24 25.62C30.1 25.76 30.02 26.03 30.07 26.23L30.31 27.26C30.5 28.07 30.07 28.39 29.35 27.96L28.35 27.37C28.17 27.26 27.87 27.26 27.69 27.37L26.69 27.96C25.97 28.38 25.54 28.07 25.73 27.26L25.97 26.23C26.01 26.04 25.94 25.76 25.8 25.62L24.97 24.79C24.48 24.3 24.64 23.81 25.32 23.69L26.39 23.51C26.57 23.48 26.78 23.32 26.86 23.16L27.45 21.98C27.74 21.34 28.26 21.34 28.58 21.98Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  badgeIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        {...props}
      >
        <rect width="56" height="56" rx="28" fill="#20BDAD" />
        <path
          d="M32.7002 34.98H23.3002C22.8802 34.98 22.4102 34.65 22.2702 34.25L18.1302 22.67C17.5402 21.01 18.2302 20.5 19.6502 21.52L23.5502 24.31C24.2002 24.76 24.9402 24.53 25.2202 23.8L26.9802 19.11C27.5402 17.61 28.4702 17.61 29.0302 19.11L30.7902 23.8C31.0702 24.53 31.8102 24.76 32.4502 24.31L36.1102 21.7C37.6702 20.58 38.4202 21.15 37.7802 22.96L33.7402 34.27C33.5902 34.65 33.1202 34.98 32.7002 34.98Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 38H33.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.5 30H30.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  chevronRightIcon: (props) => {
    return (
      <svg
        width={20}
        height={20}
        viewBox="0 0 17 16"
        fill="none"
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.44006 13.2801L10.7867 8.9334C11.3001 8.42006 11.3001 7.58006 10.7867 7.06673L6.44006 2.72006"
          stroke="white"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  plusRoundIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
      >
        <circle cx="12" cy="12" r="11.4375" stroke="currentColor" strokeWidth="1.125" />
        <path
          d="M11.8838 7.33423V16.8952"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6677 12.114H7.09692"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  imageIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Landscape-2--Streamline-Flex"
        width={46}
        height={40}
        {...props}
      >
        <desc>Landscape 2 Streamline Icon: https://streamlinehq.com</desc>
        <g id="landscape-2--photos-photo-landscape-picture-photography-camera-pictures-image">
          <path
            id="Intersect"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M1.005 10.6822c0.13308 1.2005 1.09424 2.1613 2.29419 2.2993 1.19936 0.1379 2.43638 0.2685 3.70079 0.2685 1.26441 0 2.50143 -0.1306 3.70082 -0.2685 1.1999 -0.138 2.1611 -1.0988 2.2942 -2.2993 0.1323 -1.19343 0.255 -2.42422 0.255 -3.6822 0 -1.25798 -0.1227 -2.48877 -0.255 -3.68217 -0.1331 -1.20051 -1.0943 -2.16132 -2.2942 -2.29931C9.50141 0.880585 8.26439 0.75 6.99998 0.75c-1.26441 0 -2.50143 0.130585 -3.70079 0.26852 -1.19995 0.13799 -2.16111 1.0988 -2.29419 2.29931C0.872711 4.51123 0.75 5.74202 0.75 7c0 1.25798 0.122711 2.48877 0.255 3.6822Z"
            stroke-width="1"
          ></path>
          <path
            id="Intersect_2"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.29914 12.9815c-1.19995 -0.138 -2.16111 -1.0988 -2.29419 -2.2993 -0.061234 -0.5524 -0.120417 -1.11285 -0.166327 -1.68026C1.8286 7.74434 2.98908 6.77872 4.17546 6.77872c2.40588 0 4.70526 3.97108 5.69219 6.29528 -0.93653 0.0986 -1.89401 0.176 -2.86772 0.176 -1.26441 0 -2.50143 -0.1306 -3.70079 -0.2685Z"
            stroke-width="1"
          ></path>
          <path
            id="Vector"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9.30252 6.44976c0.94738 0 1.48028 -0.53289 1.48028 -1.48026 0 -0.94736 -0.5329 -1.48026 -1.48028 -1.48026 -0.94736 0 -1.48025 0.5329 -1.48025 1.48026 0 0.94737 0.53289 1.48026 1.48025 1.48026Z"
            stroke-width="1"
          ></path>
        </g>
      </svg>
    );
  },
  editIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={20}
        height={20}
        {...props}
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 20h9"></path>
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19.001 3 20l.999-4 12.5-12.5z"></path>
      </svg>
    );
  },
  infoIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
      >
        <g clip-path="url(#clip0_2_172)">
          <path
            d="M12 22.3473C18.6222 22.3473 22.3473 18.6222 22.3473 12C22.3473 5.37775 18.6222 1.65274 12 1.65274C5.37775 1.65274 1.65274 5.37775 1.65274 12C1.65274 18.6222 5.37775 22.3473 12 22.3473Z"
            stroke="currentColor"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.001 12.7231C12.001 12.1483 12.4685 11.7958 13.2932 11.2447C14.0582 10.7335 14.4617 10.0705 14.2822 9.16814C14.1027 8.26578 13.3571 7.5202 12.4548 7.3407C11.0383 7.05896 9.67517 8.17765 9.67517 9.62184"
            stroke="currentColor"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 16.7026V16.3046"
            stroke="currentColor"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2_172">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  arrowDownIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        {...props}
      >
        <path
          d="M16.3969 7.64667C16.3969 7.64667 12.9436 13.48 10.5636 13.48C8.18439 13.48 4.73022 7.64667 4.73022 7.64667"
          stroke="#D4D4D4"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  sendIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        {...props}
      >
        <g opacity="0.6">
          <path
            d="M22.6983 2.63662C21.5472 1.51203 19.3305 1.27915 10.9407 4.64469C5.09344 6.99028 1.71589 8.37929 2.30749 11.9545C2.56728 13.5245 4.22072 15.9349 6.08013 17.8732V21.3956C6.08013 22.8826 7.88636 23.6631 9.01252 22.663L10.4344 21.4C11.4412 22.0101 12.3979 22.4376 13.1608 22.558C16.8203 23.136 18.242 19.8362 20.6429 14.1235C24.0877 5.92686 23.8493 3.7612 22.6983 2.63662Z"
            stroke="currentColor"
            stroke-width="1.75741"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.61035 17.3682C9.38383 13.5917 13.3312 10.0856 17.5045 6.80457"
            stroke="currentColor"
            stroke-width="1.75741"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    );
  },
  powerIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        {...props}
      >
        <rect width="56" height="56" rx="28" fill="#1F1F1F" />
        <g clip-path="url(#clip0_24_217)">
          <path
            d="M28 38.3473C34.6222 38.3473 38.3472 34.6222 38.3472 28C38.3472 21.3778 34.6222 17.6527 28 17.6527C21.3777 17.6527 17.6527 21.3778 17.6527 28C17.6527 34.6222 21.3777 38.3473 28 38.3473Z"
            stroke="white"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.7761 23.7737C23.5222 24.7401 22.7145 26.2569 22.7145 27.9625C22.7145 30.8816 25.0809 33.2481 28 33.2481C30.9192 33.2481 33.2856 30.8816 33.2856 27.9625C33.2856 26.2569 32.4778 24.7401 31.224 23.7737"
            stroke="white"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28 22.2045V26.9959"
            stroke="white"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_24_217">
            <rect width="24" height="24" fill="white" transform="translate(16 16)" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  graphIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        {...props}
      >
        <rect width="56" height="56" rx="28" fill="#20BDAD" />
        <g clip-path="url(#clip0_24_254)">
          <path
            d="M36.8636 25.0604C36.8636 25.0604 31.1043 23.3922 27.5726 21.9054C24.1723 20.4739 19.1367 17.6528 19.1367 17.6528"
            stroke="white"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M31.5997 38.3473H36.8068C37.6027 38.3473 38.2858 37.7592 38.3264 36.9643C38.3554 36.3971 38.3539 35.8319 38.3219 35.2646C38.2793 34.5059 37.6498 33.9279 36.8907 33.8964C35.5019 33.8387 34.294 33.8387 32.9054 33.8964C32.1461 33.9279 31.5167 34.5059 31.4741 35.2646C31.4163 36.2909 31.4582 37.3094 31.5997 38.3473Z"
            stroke="white"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.7013 38.3471H31.2978C31.4622 36.362 31.4922 34.4204 31.3878 32.4513C31.3471 31.684 30.7427 31.0682 29.9761 31.0162C28.5995 30.9228 27.3996 30.9228 26.023 31.0162C25.2564 31.0682 24.652 31.684 24.6113 32.4513C24.507 34.4204 24.537 36.362 24.7013 38.3471Z"
            stroke="white"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.3043 38.3473H24.4001C24.5754 35.3784 24.5979 32.4788 24.4675 29.5278C24.4339 28.7695 23.8594 28.1424 23.1039 28.0698C21.7081 27.9356 20.4956 27.9356 19.0998 28.0698C18.3443 28.1424 17.7698 28.7695 17.7363 29.5278C17.6279 31.9805 17.6251 34.3976 17.7279 36.8485C17.7632 37.6905 18.4615 38.3473 19.3043 38.3473Z"
            stroke="white"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M32.7385 26.8325C34.1522 26.7126 35.8006 26.0032 36.8595 25.0591C36.7395 23.6455 36.0301 21.9971 35.086 20.9382"
            stroke="white"
            stroke-width="1.7136"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_24_254">
            <rect width="24" height="24" fill="white" transform="translate(16 16)" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  heartIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        {...props}
      >
        <rect width="56" height="56" rx="28" fill="#0B1D2E" />
        <path
          d="M17.6528 24.6715C17.7223 20.0668 23.0008 15.7951 28.0001 21.8069C32.9994 15.7951 38.2779 20.0665 38.3473 24.6712C38.3473 31.5264 29.9783 37.1533 28.0001 37.1533C26.0218 37.1533 17.6528 31.5267 17.6528 24.6715Z"
          stroke="white"
          stroke-width="1.7136"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  videoIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        {...props}
      >
        <rect width="56" height="56" rx="28" fill="#F05289" />
        <path
          d="M18.7324 25.4051C19.2303 24.8633 19.8817 24.5215 20.5805 24.4354C22.7571 24.1808 24.8961 24.1805 27.0727 24.4354C27.7714 24.5215 28.4228 24.8633 28.9207 25.4051C29.4186 25.9468 29.7335 26.6567 29.8142 27.4188C29.8514 27.7809 29.883 28.1411 29.909 28.4998C30.439 28.1921 31.0098 27.9082 31.604 27.6774C32.2571 27.4237 32.9723 27.7343 33.182 28.4029C33.3905 29.0673 33.572 29.9575 33.572 30.9807C33.572 32.0039 33.3905 32.8941 33.182 33.5586C32.9723 34.227 32.2571 34.5377 31.604 34.284C31.0097 34.0532 30.4388 33.7692 29.9087 33.4615C29.883 33.8203 29.8518 34.1805 29.8152 34.5427C29.7345 35.3049 29.4196 36.0147 28.9217 36.5564C28.4239 37.0983 27.7724 37.4401 27.0737 37.526C24.8966 37.7806 22.7575 37.7807 20.5805 37.526C19.8817 37.4401 19.2303 37.0983 18.7324 36.5564C18.2346 36.0147 17.9196 35.3049 17.839 34.5427C17.5917 32.1392 17.5919 29.8223 17.839 27.4188C17.9196 26.6567 18.2346 25.9468 18.7324 25.4051Z"
          stroke="white"
          stroke-width="1.7136"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M31.4636 17.6528C33.2895 17.6528 35.0406 18.3781 36.3316 19.6692C37.6228 20.9603 38.3481 22.7113 38.3481 24.5372"
          stroke="white"
          stroke-width="1.7136"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M31.4636 22.1494C32.0969 22.1494 32.7043 22.4009 33.152 22.8488C33.5998 23.2966 33.8515 23.9039 33.8515 24.5372"
          stroke="white"
          stroke-width="1.7136"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },

  // Additional icons for health scheme form
  edit: (props) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.1666 2.5C14.3856 2.28113 14.6454 2.10752 14.9314 1.98906C15.2173 1.87061 15.5238 1.80965 15.8333 1.80965C16.1427 1.80965 16.4492 1.87061 16.7351 1.98906C17.0211 2.10752 17.281 2.28113 17.5 2.5C17.7188 2.71887 17.8924 2.97871 18.0109 3.26468C18.1294 3.55064 18.1903 3.85714 18.1903 4.16667C18.1903 4.47619 18.1294 4.78269 18.0109 5.06865C17.8924 5.35462 17.7188 5.61446 17.5 5.83333L6.24999 17.0833L1.66666 18.3333L2.91666 13.75L14.1666 2.5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  trash: (props) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.5 5H4.16667H17.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66667 5V3.33333C6.66667 2.89131 6.8423 2.46738 7.15486 2.15482C7.46743 1.84226 7.89131 1.66667 8.33333 1.66667H11.6667C12.1087 1.66667 12.5326 1.84226 12.8452 2.15482C13.1577 2.46738 13.3333 2.89131 13.3333 3.33333V5M15.8333 5V16.6667C15.8333 17.1087 15.6577 17.5326 15.3452 17.8452C15.0326 18.1577 14.6087 18.3333 14.1667 18.3333H5.83333C5.39131 18.3333 4.96738 18.1577 4.65482 17.8452C4.34226 17.5326 4.16667 17.1087 4.16667 16.6667V5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  chevronUp: (props) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M15 12.5L10 7.5L5 12.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  documentText: (props) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 2V8H20"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 13H8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 17H8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 9H9H8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  upload: (props) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 8L12 3L7 8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 3V15"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
};

export default Icons;
